import {useEffect, useState} from 'react'

import {Button, Center} from '@mantine/core'
import {Modal} from 'react-bootstrap'
import {
  changeTextCapital,
  sortEmailsDescending,
} from '../../../_metronic/helpers/AssetHelpers'
import FeatureGate from '../../components/FeatureGate'
import {FEATURE_KEYS} from '../../features/featureRegistry'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import InputErrorBox from '../../components/InputErrorBox'
import {
  cancelSubmit,
  deleteDesignation,
  getDesignation,
  getDesignationById,
  handleInputChange,
  handleSubmit,
  validateForm,
} from './DesignationFunction'

const Designation = () => {
  const [designation, setDesignation] = useState([{id: '', designationName: ''}])
  const [searchTerm, setSearchTerm] = useState('')
  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  const initialState = {designationName: '', date: ''}
  const [inputField, setInputField] = useState(initialState)
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      getDesignation((fetchedEmails) => {
        const sortedEmails = sortEmailsDescending(fetchedEmails)
        setDesignation(sortedEmails)
        setAPIStatus({
          loading: false,
          error: null,
          submitLoading: false,
        })
      }, setAPIStatus)
      setIsAddUserModalOpen(false)
    }
    return () => {
      mounted = false
    }
  }, [])

  const handleClose = () => {
    setIsAddUserModalOpen(false)
  }

  return (
    <>
      <Modal
        show={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        animation={false}
        backdrop='static'
        onRequestClose={handleClose}
        centered
      >
        {/* begin::modal header--add holiday */}
        <div className='modal-header'>
          <h2 className='fw-bolder'>Add Designation</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              handleClose()
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Designation Name</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='text'
              placeholder='Designation Name...'
              name='designationName'
              value={inputField.designationName}
              onChange={(event) => handleInputChange(event, setInputField, inputField)}
            />
            {<InputErrorBox Message={inputError.designationName} />}
          </div>
          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
                setInputError('')
              }}
              type='button'
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{marginLeft: '15px'}}
              disabled={SubmitAPIStatus?.loading}
            >
              Clear
            </Button>
            <Button
              loaderPosition='center'
              type='submit'
              className='btn btn-primary btn-sm font-weight-bold h-10'
              loading={SubmitAPIStatus.loading}
              onClick={() => {
                handleSubmit(
                  inputField,
                  getDesignation,
                  setDesignation,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  setInputError,
                  validateForm,
                  setSubmitAPIStatus,
                  setIsAddUserModalOpen
                )
              }}
            >
              {editId !== null ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </Modal>
      {/* //end of the form */}

      <div className='row g-5 g-xl-8 justify-content-center'>
        <div className='col-xl-8'>
          {/* begin:: card */}
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin:: card header */}
            <div className='card-header'>
              <div className='card-title'>Designation</div>
              <div className='d-flex align-items-center gap-3'>
                {/* Search Bar */}
                <input
                  type='text'
                  placeholder='Search Designation...'
                  className='form-control form-control-sm w-250px'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {/* Begin::Add User button */}

                <FeatureGate feature={FEATURE_KEYS.users_designations}>
                  <button
                    type='button'
                    className='btn btn-sm btn-primary'
                    onClick={() => {
                      setIsAddUserModalOpen(true)
                    }}
                  >
                    Add Designation
                  </button>
                </FeatureGate>

                {/* end::Add user button */}
              </div>
            </div>
            {/* begin:: card body */}
            <div className='card-body'>
              {APIStatus.submitLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : APIStatus.error != null ? (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{APIStatus.error}</div>
                </div>
              ) : (
                <div className='table-responsive  '>
                  <table
                    className='table 
                    table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                  >
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>
                          {changeTextCapital('Sr.No')}
                        </th>
                        <th className='pl-1 flex-start text-muted' style={{minWidth: '150px'}}>
                          {changeTextCapital('Designation Name')}
                        </th>

                        <th
                          className='pl-1 text-center text-muted'
                          style={{minWidth: '100px'}}
                        >
                          {changeTextCapital('Actions')}
                        </th>
                      </tr>
                    </thead>
                    {designation?.length > 0 ? (
                      <tbody className='text-gray-800 fw-semibold text-left'>
                        {/* {designation.map((obj: any, index: number) => ( */}
                        {designation
                          .filter((obj: any) =>
                            obj?.name?.toLowerCase().includes(searchTerm.toLowerCase())
                          )
                          .map((obj: any, index: number) => (
                          <tr
                            className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
                            key={obj?.id ?? '-'}
                          >
                            <td className='text-center'>{index + 1}</td>
                            <td className='flex-start'>{obj?.name ?? '-'}</td>
                            <FeatureGate feature={FEATURE_KEYS.users_designations}>
                            <td>
                              <div className='d-flex justify-content-center flex-shrink-0'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1'
                                  onClick={() => {
                                    document.getElementById('holidayName')?.focus()
                                    getDesignationById(
                                      obj.id,
                                      inputField,
                                      setInputField,
                                      setEditId,
                                      setInputError
                                    )
                                    setIsAddUserModalOpen(true)
                                  }}
                                >
                                  <i className='far fa-edit'></i>
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                                  onClick={() =>
                                    deleteDesignation(
                                      obj.id,
                                      getDesignation,
                                      setDesignation,
                                      setAPIStatus,
                                      cancelSubmit,
                                      setInputField,
                                      initialState,
                                      setEditId,
                                      setInputError
                                    )
                                  }
                                >
                                  <i className='fa fa-trash'></i>
                                </button>
                              </div>
                            </td>
                            </FeatureGate>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={5}>
                            <Center>No Record Available.</Center>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Designation
